import styled from 'styled-components'
import Typography, { FontWeights } from 'builder/styles/typography'
import Colors from 'builder/styles/colors'

/** Tabs Navigation */
export const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 2rem;
  margin: 0 auto;
`

export const TabItem = styled.button<{ isActive: boolean }>`
  ${Typography.Body}
  ${FontWeights.Regular}
  color: ${Colors.Neutral90};
  border: 1px solid;
  border-color: ${Colors.Neutral15};
  border-radius: 32px;
  text-align: center;
  padding: 12px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.Blue10};
    border-color: ${Colors.Blue10};
    color: ${Colors.Blue80};
  }

  ${props =>
    props.isActive &&
    `
      background-color: ${Colors.Blue10};
      border-color: ${Colors.Blue30};
      color: ${Colors.Blue80};
      &:hover {
        border-color: ${Colors.Blue30}; 
      }
  `}
`
export const ConnectorLine = styled.div<{ isActive: boolean }>`
  height: 2px;
  width: 24px;
  background-color: ${({ isActive }) => (isActive ? Colors.Blue30 : Colors.Neutral20)};
  border-radius: 1px;
  transition: background-color 0.2s;
`
